<app-modal-header
  [highlighted]="true"
  (close)="close()">
  <span slot="breadcrumb">
    {{ 'admin.google-calendar-create-connection-modal.title' | translate }}
  </span>
  <span slot="title">

  </span>
</app-modal-header>

<div class="modal-body" [formGroup]="form">
  <div class="col-12 flex flex-column row-gap-2">
    <span class="font-bold">{{ 'admin.google-calendar-create-connection-modal.connection-name.label' | translate }}</span>
    <input type="text" pInputText formControlName="connectionTitle" [placeholder]="'admin.google-calendar-create-connection-modal.connection-name.placeholder' | translate" />
  </div>

  <div class="col-12 py-2">
    <span>{{ 'admin.google-calendar-create-connection-modal.connection-name.description' | translate }}</span>
  </div>

</div>

<div class="modal-footer justify-content-between">
  <button
    (click)="close()"
    pButton
    label="{{ 'admin.google-calendar-create-connection-modal.cancel-btn.label' | translate }}"
    class="p-button-text p-button-plain">
  </button>

  <button
    [loading]="fetchingAuthUrl"
    [disabled]="fetchingAuthUrl"
    (click)="onSubmit()"
    pButton
    label="{{ 'admin.google-calendar-create-connection-modal.submit-btn.label' | translate }}"
    class="flex">
    <app-google-icon class="mr-2" />
  </button>
</div>
